export default {
  baseStyle: () => ({
    dialog: {
      bg: '#1a1a1cf6',
      color: 'white',
    },
  }),
};
